export const getOptionConfig = (barData, lang, that) => {
  let legendData = []
  let series = []
  barData.forEach((element, index) => {
    legendData.push(element.apiName)
    series.push({
      name: element.apiName,
      type: 'bar',
      data: [element.num],
      itemStyle: {
        normal: {
          label: {
            // 每个bar的最高点值显示在bar顶部
            show: true,
            position: 'top',
            // 值和x轴分类的显示格式(这里是换行显示)
            formatter: '{c}'
          }
        }
      }
    })
  })
  return {
    color: [
      '#6A94E7',
      '#F3C985',
      '#999EF5',
      '#6ACCE7',
      '#A797DF',
      '#83DAC2',
      '#899EC9',
      '#9882B5',
      '#CC9F82',
      '#94CD86',
      '#FF7D33',
      '#32B84C',
      '#1890FF',
      '#946ADE',
      '#80CEBE',
      '#FF4D4D',
      '#A3D84A',
      '#cca272',
      '#74608f',
      '#d7a02b',
      '#c8ba23'
    ],
    grid: {
      left: '8%',
      right: '0',
      top: '10%',
      bottom: '16%',
      containLabel: true
    },
    title: {
      text: that.$t('statistics.more'),
      link: 'javascript:goDetail()',
      target: 'self',
      textStyle: {
        fontSize: 17,
        color: '#333333',
        fontWeight: 500
      },
      right: 10
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: ''
      },
      backgroundColor: '#ffffff',
      borderWidth: 1,
      borderColor: 'rgba(0,0,0,0.2)',
      formatter: function(params) {
        let tempStr = ''
        params.forEach(item => {
          tempStr += `<div class="tooltip-content">
           <span class="tooltip-title-left">${item.seriesName}：</span>
           <sapn class="tooltip-title-right"> ${item.value} </sapn>
         </div>`
        })
        var str = `<div class="tooltip">
              <div class="tooltip-title note-circle-blue">${that.$t(
    'statistics.apiSort'
  )}</div>
              ${tempStr}
         </div>`
        return str
      }
    },
    legend: {
      data: legendData,
      bottom: 10
    },
    xAxis: [
      {
        type: 'category',
        show: false,
        data: [that.$t('statistics.apiSort')]
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false
        },
        splitLine: {
          lineStyle: {
            // 使用深浅的间隔色
            color: 'rgba(0,0,0,0.2)',
            type: 'dashed'
          }
        }
      }
    ],
    series: series
  }
}



// WEBPACK FOOTER //
// ./src/modules/statistics/apiStatistics/apiBarChar.js